// removed by extract-text-webpack-plugin
module.exports = {"card":"card","card-heading":"card-heading","card-title":"card-title","card-content":"card-content"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/dashboard/component/card/card.style.sass
// module id = SKa4
// module chunks = 0